import React from 'react';
import { MaterialsPanel } from '../../components/shared/MaterialsPanel';
export function AdminMaterials() {
  return <div className="space-y-5" data-id="element-1104" data-mp="2ayz5zizk1g1">
      <div data-id="element-1105" data-mp="2c0jkulw60af">
        <h1 className="text-2xl font-semibold text-ink" data-id="element-1106" data-mp="2ca0ztsvez4i">Gradiva</h1>
        <p className="mt-0.5 text-sm text-ink-muted" data-id="element-1107" data-mp="3tn0m3li2fttz">
          Skupna Google Drive mapa je dostopna vsem članom zbora.
        </p>
      </div>
      <MaterialsPanel data-id="element-1108" data-mp="3jq5nz3ppfvg8" />
    </div>;
}